import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useGetSubjectsQuery } from '../../slices/teachers/subjectApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import Subject from '../../components/Subject';
import NoTeacherSubject from '../../components/NoTeacherSubject';
import PaginateNewAnswers from '../../components/PaginateNewAnswers';
import { colors } from '../../colorConstant';

const TeacherSubjects = () => {

    const { pageNumber } = useParams();
    const navigate = useNavigate();

    const colors2 = [];

    const { data, isLoading, error } = useGetSubjectsQuery({pageNumber});

    for (let i = 0; i < data?.subjects?.length; i++) {
        colors2.push(colors[i]);
    }

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])

    return (
        <div>
            <TeacherNavbar /> 
            <div className="main-content" id="panel">
                <TeacherHeader />   
                <br /><br /><br /><br />
                <div className="container-fluid mt--6">
                    {isLoading ? ( 
                        <Loader />
                    ) : error ? (
                        <Message variant='danger'>
                            {error?.data?.message || error.error}
                        </Message>
                    ) : (
                        <div className="row">
                            <h3 className="centerTitle tittleColor4 ">
                                <span className='tittleColor4'>
                                   My Subjects
                                </span>
                            </h3><br /><br />
                            {data?.subjects.map((subject, index) => (
                                <div key={subject._id} className="col-md-6  col-xl-4 ">
                                    <Subject subject={subject} color={colors2[index]} />
                                </div>
                            ))}
                            {data?.subjects.length === 0 && 
                                <div  className="col-md-6  col-xl-4 ">
                                    <NoTeacherSubject />
                                </div>
                            }
                            <PaginateNewAnswers
                            pages={data?.pages}
                            page={data?.page}
                            link={`teachersubjects`}
                            className='pagCenterStudent'                                                
                        />
                        </div>
                    )} 
                </div>
            </div>
        </div>
    );
};

export default TeacherSubjects;